import * as React from 'react'

import { Goals as GoalsIcon } from '@factorialco/factorial-one-react/icons/modules'

import i18n from 'modules/core/lib/i18n'
import { type NavigationRoutesFn, buildModuleRoute } from 'modules/core/lib/react-router'

import goalsConfig from 'modules/goals/store/collections/goalsconfig'

const GoalConfig = React.lazy(() => import('modules/goals/pages/my_goals/GoalConfig'))
const GoalsPage = React.lazy(() => import('modules/goals/pages/my_goals/GoalsPage'))
const RootPage = React.lazy(() => import('modules/goals/pages/RootPage'))

export const goalsRoutes: NavigationRoutesFn = (navigation) => [
  buildModuleRoute({
    path: navigation.goals.path,
    element: <RootPage />,
    handle: {
      module: 'goals',
      moduleName: () => i18n.t('goals.my_goals.header.title'),
      moduleIcon: GoalsIcon,
      meta: () => ({
        title: i18n.t('goals.my_goals.header.title'),
      }),
    },
    children: [
      {
        index: true,
        element: <GoalsPage />,
      },
      {
        path: navigation.goals.id.path,
        element: <GoalConfig />,
        loader: ({ params }) => {
          return goalsConfig.fetch({ data: { id: Number(params.id) } })
        },
        handle: {
          meta: ({ params }) => {
            const goalConfig = goalsConfig.get(Number(params.id))

            return Promise.resolve({
              title: goalConfig?.attributes.name ?? i18n.t('surveys.goals.common.goal'),
            })
          },
        },
      },
    ],
  }),
]
